import { DATE_FORMAT, DATE_TIME_FORMAT } from 'CORE/utils/date'
import labels from 'CORE/utils/labels'
import FileSaver from 'file-saver'
import { get, find, map, isString } from 'lodash'
import moment from 'moment'

export default {
    methods: {
        exportTableData() {
            const pvExportValue = (v, k) => {
                const pt = this.$store.getters.propertyTypeByKey(k)
                const ptType = get(pt, 'type')
                const value = get(v, 'value.value')
                switch (ptType) {
                    case 'DATE_TIME':
                        return moment(value, 'X').format(DATE_TIME_FORMAT)
                    case 'DATE':
                        return moment(value, 'X').format(DATE_FORMAT)
                    case 'LONGTEXT':
                        if (isString(value)) {
                            return value.replace(/"/g, '')
                        }
                        return ''
                    case 'LINK_PERSON_RESOURCE':
                    case 'LINK_THING_RESOURCE':
                    case 'LINK_PLACE_RESOURCE':
                        return map(value, rid => {
                            return labels.resource(this.$store.getters.resourceById(rid))
                        }).join(', ')
                    case 'LINK_USER':
                        return map(value, uid => {
                            return get(this.$store.getters.userById(uid), 'username')
                        }).join(', ')
                    case 'BOOLEAN':
                        return value ? 'Ano' : 'Ne'
                    case 'ENTITY_STATE':
                        const graphId = get(pt, 'settings.entity_state.graph')
                        const graph = get(this.$store.getters.currentUser, `company.settings.entity-states.${graphId}`, {})
                        return get(find(get(graph, 'states'), { id: value }), 'label', '-- unknown state --')
                    case 'LINK':
                        const linkType = get(pt, 'settings.link.entity')
                        return map(value, id => {
                            if (linkType === 'TASK') {
                                return labels.task(this.$store.getters.taskById(id))
                            } else if (linkType === 'PROJECT') {
                                return labels.project(this.$store.getters.getProjectById(id))
                            } else {
                                return '-- unknown link type --'
                            }
                        }).join(', ')
                    case 'STATIC_STRING':
                    default:
                        return get(v, 'value.value')
                }
            }
            const data = map(this.exportEntities, p => {
                const pv = get(p, 'propertyValues')
                return map(this.exportKeys, k => {
                    if (get(pv, k, false)) {
                        return pvExportValue(get(pv, k), k)
                    }
                    return null
                })
            })
            const header = map(this.exportKeys, k => {
                return get(this.$store.getters.propertyTypeByKey(k), 'name', k)
            })
            const blobString = map([header, ...data], r => {
                return map(r, c => c === null ? '' : `"${c}"`).join(',')
            }).join(`\n`)

            let filename = 'asd-export'
            try {
                filename = this.$route.fullPath.replace(/[^a-z0-9]+/g, '-').replace(/^\-/, '')
            } catch (e) {
                console.warn(e)
            }
            const blob = new Blob([blobString], { type: 'text/csv;charset=utf-8' })
            FileSaver.saveAs(blob, `${filename}.csv`)
        },
    },
}
